import SingleReportPage from "./SingleReportPage";

const PRODUCT_OPTIONS = [
  { value: "sky", label: "Sky Products" },
  { value: "converge", label: "Converge Products" },
  { value: "all", label: "All" },
];

export default function ContractorOutputPage() {
  return (
    <SingleReportPage
      title="Daily Contractor Output"
      label="Agency"
      endpoint="/reports/contractor-output"
      productFilter={{ options: PRODUCT_OPTIONS, defaultValue: "sky" }}
    />
  );
}
